//for phone mask
var inputTel, themePath, iti,
    errorMap = {
        0 : {
            'en': 'invalid number',
            'ru': 'некорректный номер'
        },
        1 : {
            'en': 'invalid country code',
            'ru': 'неверный код страны'
        },
        2 : {
            'en': 'the number is too short',
            'ru': 'слишком короткий номер'
        },
        3 : {
            'en': 'the number is too long',
            'ru': 'слишком длинный номер'
        },
        4 : {
            'en': 'invalid number',
            'ru': 'некорректный номер'
        },
    };
function initTelInput() {
    if(!document.getElementById("phone")) return;
    if (themePath == undefined) themePath = '';
    inputTel = document.getElementById("phone");
    var formGroupTel = inputTel.closest('.form__group');
    iti = window.intlTelInput(inputTel, {
        initialCountry: "auto",
        geoIpLookup: function(callback) {
            $.get("//ipinfo.io", function() {}, "jsonp").always(function(resp) {
                var countryCode = (resp && resp.country) ? resp.country : "";
                callback(countryCode);
            });
        },
        separateDialCode: true,
        utilsScript: themePath + "/templates/meetbrides_new/vjs/components/intltelinput/utils.js",
    });
    if(iti) formGroupTel.classList.add('upLabel');
}
//for validation form
var lang = document.documentElement.getAttribute('lang'),
    formLang = lang == '' || lang == undefined || lang != 'ru' ? 'en' : lang,
    ageLimit = 18,
    validateNecessarily = [],
    formRegister = ['formRegister'],
    formAuth = [],
    formForgot = [],
    formProfile = [],
    notActionForm = [],
    notClearForm = ['formRegister'],
    notModalForm = ['formRegister'],
    fieldEmail = ['email'],
    fieldPass = ['pass','newpass','renewpass'],
    fieldPassRepeat = {
        'formRePass' : ['newpass','renewpass'],
    }
    fieldNoNumber = ['fname'],
    fieldOnlyNumber = ['id'],
    fieldBirthday = [],
    fieldReg = {
        noNumber: {
            'pattern': /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/i,
            'fieldTooltip':{
                'en': 'fill in the "name" field correctly',
                'ru': 'заполните корректно поле "имя"'}
        },
        onlyNumber: {
            'pattern': /^[0-9]+$/,
            'fieldTooltip':{
                'en':'the field can contain only numbers',
                'ru':'поле может содержать только цифры'}
        },
        birthday: {
            'pattern': {
                'day': /^(1|2|3)\d{0,}$|^0[1-9]$/,
                'year': /^(?:19|20)\d{0,}$/,
            },
            'fieldTooltip':{
                0 : {
                    'en':'fill in the "birthday" fields correctly',
                    'ru':'заполните корректно поля "день рождения"'
                },
                1 : {
                    'en':'fill in the "year" field correctly',
                    'ru':'заполните корректно поле "год"'
                },
                2 : {
                    'en':'fill in the field "year" in the format "YYYY"',
                    'ru':'заполните поле "год" в формате "ГГГГ"'
                },
                3 : {
                    'en':'fill in the "day" field correctly',
                    'ru':'заполните корректно поле "день"'
                },
                4 : {
                    'en':'fill in the field "day" in format "DD"',
                    'ru':'заполните поле "день" в формате "ДД"'
                },
                5 : {
                    'en': 'enter valid date to pass '+ ageLimit +' years age limitation',
                    'ru': 'введите правильную дату, чтобы пройти ограничение возраста '+ ageLimit +' лет'
                },
            }
        },
        email: {
            'pattern': /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/i,
            'fieldTooltip':{
                'en':'enter your valid email address',
                'ru':'введите правильный e-mail'}
        },
        pass: {
            'pattern': /^(?=.*[A-Za-zА])(?=.*\d).{6,}/,
            'fieldTooltip':{
                'en':'password must be at least 6 characters long and contain letters and numbers',
                'ru':'пароль должен быть не менее 6 символов и содержать буквы и цифры'},
            'fieldTooltipCorrectly':{
                'en':'passwords didn\'t match, try again',
                'ru':'пароли не совпадают, повторите попытку'}
        },
        heightUser: {
            'pattern': /^\d{2,3}$/i,
            'fieldTooltip':{
                'en':'indicate your height in in.(sm.)',
                'ru':'укажите свой рост в дюймах(см.)'}
        },
        weightUser: {
            'pattern': /^\d{2,3}$/i,'fieldTooltip':{
                'en':'indicate your weight in lbs.(kg.)',
                'ru':'укажите свой вес в фунтах(кг.)'}
        },
    },
    fieldTooltipText = {
        empty: {
            'en':'fill in the field',
            'ru':'заполните поле'
        },
        check: {
            'en':'check the box',
            'ru':'поставьте галочку'
        },
        captcha: {
            'en':'fill in CAPTCHA field',
            'ru':'заполните поле CAPTCHA'},
        file: {
            'en':'field "Choose file" not completed in a proper',
            'ru':'поле "Выбрать файл" не заполнено должным образом'},
        correctly:{
            'en':'fill in the field correctly',
            'ru':'заполните корректно поле'},
        phone:{
            'en':'indicate phone number',
            'ru':'укажите номер телефона'},
    },
    fieldTooltip = fieldTooltipText['empty'][formLang],
    textPopUp = {
        all : {
            'successfully': {
                'en':'Your message has been successfully sent.',
                'ru': 'Ваше сообщение успешно отправлено.'
            },
            'problem':{
                'en': 'Sorry, there are problems sending the message.',
                'ru': 'Извините, при отправке сообщения возникли проблемы.'
            }
        },
        register : {
            'successfully': {
                'en': 'You have successfully registered.',
                'ru': 'Вы успешно зарегистрировались.'
            },
            'problem':{
                'en': 'Sorry, there are problems registering.',
                'ru': 'Извините, при регистрации возникли проблемы.'
            }
        },
        auth : {
            'successfully': {
                'en': 'You have successfully logged in.',
                'ru': 'Вы успешно авторизировались.'
            },
            'problem':{
                'en': 'Sorry, there are problems with authorization.',
                'ru': 'Извините, при авторизации возникли проблемы.'
            }
        },
        forgot : {
            'successfully': {
                'en': 'An email will be sent to your email address that includes a password reset link.',
                'ru': 'На ваш электронный адрес будет отправлено письмо со ссылкой для восстановления пароля.'
            },
            'problem':{
                'en': 'Sorry, there are problems recovering your password.',
                'ru': 'Извините, при восстановлении пароля возникли проблемы.'
            }
        },
        personal : {
            'successfully': {
                'en': 'Your data has been successfully saved.',
                'ru': 'Ваши данные были успешно сохранены.'
            },
            'problem':{
                'en': 'Sorry, there was a problem saving your data.',
                'ru': 'Извините, при сохранении данных возникли проблемы.'
            }
        },
    },
    focusField = ['loginfields','to'],
    fieldValid = [], passConfirm = [];

function Validator(el,e) {
    e.preventDefault();
    var $FORM = el;
    var validatorEl = $FORM.getAttribute('id');
    var formType = selected(formRegister, validatorEl) ? 'register' : (selected(formAuth, validatorEl) ? 'auth' : (selected(formForgot, validatorEl) ? 'forgot' : (selected(formProfile, validatorEl) ? 'personal' : 'all')));
    var successfullyMessage = textPopUp[formType]['successfully'][formLang];
    var problemMessage = textPopUp[formType]['problem'][formLang];
    var validatorInit = function () {
        var validate = {
            validField: function () {
                var elements = $FORM.elements,
                    captcha = $FORM.querySelector('.captcha'),
                    validReturn = false;
                fieldValid.length = 0;
                passConfirm.length = 0;
                for (var i = 0; i < elements.length; i++) {
                    if (elements.item(i).classList.contains('required')) {
                        Required.requiredField(elements.item(i));
                    } else if (elements.item(i).classList.contains('text-input') || elements.item(i).classList.contains('textarea') || elements.item(i).classList.contains('select')) {
                        if(selected(validateNecessarily, validatorEl)) Required.validValidate(elements.item(i));
                    }
                }
                if (captcha && captcha.classList.contains('required')) Required.requiredField(captcha);
                !selected(fieldValid, false) ? validReturn = true : validReturn = false;
                return validReturn;
            },
            serialize: function () {
                var field, l, s = [];
                if (typeof $FORM == 'object' && $FORM.nodeName == "FORM") {
                    var len = $FORM.elements.length;
                    for (var i = 0; i < len; i++) {
                        field = $FORM.elements[i];
                        if (field.name && !field.disabled && field.type != 'button' && field.type != 'reset' && field.type != 'submit' && field.type != 'hidden') {
                            if (field.type == 'select-multiple') {
                                l = $FORM.elements[i].options.length;
                                for (var j = 0; j < l; j++) {
                                    if (field.options[j].selected) {
                                        s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[j].value);
                                    }
                                }
                            } else if ((field.type != 'checkbox' && field.type != 'radio') || field.checked) {
                                s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value);
                            }
                        }
                    }
                }
                return s.join('&').replace(/%20/g, '+');
            },
            submitForm: function () {
                //console.log(this.serialize());
                $.ajax({
                    type: $FORM.getAttribute('method'),
                    url: $FORM.getAttribute('action'),
                    data: this.serialize()
                }).done(function (data, textStatus, jqXHR) {
                    if (!selected(notModalForm, validatorEl)) swal({ text: successfullyMessage });
                    setTimeout(function () {
                        if (!selected(notClearForm, validatorEl)) clearField($FORM);
                    }, 2000);
                }).fail(function (jqXHR, textStatus, errorThrown) {
                    if (!selected(notModalForm, validatorEl)) swal({ text: problemMessage });
                    swal({ text: problemMessage });
                    setTimeout(function () {
                        validate.resetCaptca();
                    }, 2000);
                });
                return false;
            },
        }
        if (validate.validField()){
            goForm(' ',' ');
            if(localStorage.getItem('form')) localStorage.removeItem('form');
            selected(notActionForm, validatorEl) ? validate.submitForm() : $FORM.submit();
        }else{
            return false;
        }
    };
    validatorInit($FORM);
}
function checkCall(count, id) {
    return new Promise(function(resolve, reject){
        if (count < call_price) {
            return reject(new Error('InvalidCount'));
        }
        if(!id){
            return reject(new Error('emptyID'));
        }
        $.ajax({
            type: "POST",
            url: "/ajax.php?com=check_lady",
            data: {"id": id},
            cache: false,
            async: false,
            success: function (response) {
                if (response) {
                    response = $.parseJSON(response);
                    if (response.error !== "ok") {
                        return reject(new Error('InvalidID'));
                    }
                    resolve(response);
                }
            },
            fail : function (e, textStatus){
                reject(new Error(textStatus));
            }
        });
    });
}
//for validation required field
var fieldEl, fieldVal, idForm;
var Required = {
    requiredField: function(e){
        fieldEl = e.target !== undefined ? e.target : e;
        idForm = fieldEl.closest('form').getAttribute('id');
        var fieldName =  fieldEl.classList.contains('captcha') ? 'captcha' : fieldEl.getAttribute('name');
        var initValidate = function(fieldEl,fieldName,fieldVal) {
            if(!fieldVal){
                if(fieldEl.type == 'checkbox' || fieldEl.type == 'radio'){
                    Required.invalidValidate(fieldEl,fieldTooltipText['check'][formLang]);
                }else if(fieldEl.type == 'file'){
                    Required.uploadValidate(fieldEl,fieldVal);
                }else if(fieldEl.type == 'number'){
                    Required.onlyNumberValidate(fieldName,fieldVal);
                }else{
                    Required.invalidValidate(fieldEl,fieldTooltipText['empty'][formLang]);
                }
            } else if(selected(fieldNoNumber, fieldName)){
                Required.noNumberValidate(fieldName,fieldVal);
            } else if(selected(fieldOnlyNumber, fieldName)){
                Required.onlyNumberValidate(fieldName,fieldVal);
            } else if(selected(fieldPass, fieldName)){
                Required.passwordValidate(fieldName,fieldVal);
            } else if(selected(fieldEmail, fieldName)){
                Required.emailValidate(fieldName,fieldVal);
            } else if(selected(fieldBirthday, fieldName)){
                Required.birthdateValidate(fieldName,fieldVal);
            } else if(selected(Object.keys(fieldReg), fieldName)){
                !fieldVal.match(fieldReg[fieldName]['pattern']) ? Required.invalidValidate(fieldEl,fieldReg[fieldName]['fieldTooltip'][formLang]) : Required.lengthValidate(fieldName, fieldVal);
            } else if(fieldName === 'phone_number'){
                Required.telValidate(fieldName,fieldVal);
            }else if(fieldEl.type == 'file'){
                Required.uploadValidate(fieldEl,fieldVal);
            }else if(fieldName === 'captcha'){
                Required.captchaValidate(fieldEl);
            }else{
                Required.lengthValidate(fieldName);
            }
        };
        if(fieldEl.type == 'checkbox' || fieldEl.type == 'radio'){
            fieldEl.checked ? fieldVal = 'checked' : fieldVal = '';
        } else if(fieldName === 'captcha'){
            fieldVal = Required.captchaVal(fieldEl);
        } else if(fieldEl.type == 'file'){
            if(e.target !== undefined){
                fieldVal = fieldEl.files.length > 0 ? 'file' : '';
            }else{
                fieldVal = fieldEl.value;
            }
        } else {
            fieldVal = fieldEl.value.trim();
        }
        fieldName === 'captcha' ? initValidate(fieldEl,fieldName,fieldVal) : (!fieldVal.match('\<(\/?[^>]+)>|--|\/\/') ? initValidate(fieldEl,fieldName,fieldVal) : this.invalidValidate(fieldEl,fieldTooltipText['correctly'][formLang]));
    },
    lengthValidate: function(fieldName) {
        var fieldEl = document.querySelector('[name="'+ fieldName +'"]');
        var lengthVal = fieldEl.value.trim().length,
            lengthMin = fieldEl.getAttribute('minlength'),
            lengthMax = fieldEl.getAttribute('maxlength'),
            lengthText = {
                'en' : selected(fieldNoNumber, fieldName) ? ' letters' : (selected(fieldOnlyNumber, fieldName) ? ' numbers' : ' characters'),
                'ru' : selected(fieldNoNumber, fieldName) ? ' букв' : (selected(fieldOnlyNumber, fieldName) ? ' цифр' : ' символов')
            },
            lengthTooltip = {
                strong: {
                    'en' : 'enter '+ (lengthMin || lengthMax) + lengthText[formLang],
                    'ru' : 'введите '+ (lengthMin || lengthMax) + lengthText[formLang]
                },
                range: {
                    'en' : 'enter '+ lengthMin +' to '+ lengthMax + lengthText[formLang],
                    'ru' : 'введите от '+ lengthMin +' до '+ lengthMax + lengthText[formLang]
                },
                min: {
                    'en' : 'enter more than '+ lengthMin + lengthText[formLang],
                    'ru' : 'введите более '+ lengthMin + lengthText[formLang]
                },
                max: {
                    'en' : 'enter less than '+ lengthMax + lengthText[formLang],
                    'ru' : 'введите меньше '+ lengthMax + lengthText[formLang]
                },
            };
        if(lengthMin && lengthMax){
            if(lengthMin == lengthMax){
                if(lengthMin == lengthVal || lengthMax ==  lengthVal){
                    if(fieldName == 'id'){
                        var count = parseInt(document.getElementById("count").value),
                            id = parseInt(fieldEl.value);
                        var $this = this;
                        checkCall(count, id).then(function (){
                            $this.validValidate(fieldEl);
                        })['catch'](function(e){
                            if(e.message === 'InvalidCount'){
                                return swal({ text: 'You must have a minimum of '+ call_price +' credits' });
                            }
                            $this.invalidValidate(fieldEl,fieldTooltipText['correctly'][formLang] + ' ID number');
                        });
                    } else{
                        this.validValidate(fieldEl);
                    }
                } else {
                    this.invalidValidate(fieldEl,lengthTooltip['strong'][formLang]);
                }
            } else{
                lengthMin <= lengthVal && lengthVal <= lengthMax ? this.validValidate(fieldEl) : this.invalidValidate(fieldEl,lengthTooltip['range'][formLang]);
            }
        } else if(lengthMin && !lengthMax){
            lengthMin <= lengthVal ? this.validValidate(fieldEl) : this.invalidValidate(fieldEl,lengthTooltip['min'][formLang]);
        } else if(!lengthMin && lengthMax){
            lengthMax >= lengthVal ? this.validValidate(fieldEl) : this.invalidValidate(fieldEl,lengthTooltip['max'][formLang]);
        } else {
            this.validValidate(fieldEl);
        }
    },
    birthdateValidate: function(fieldName,fieldVal) {
        var dataYear = document.querySelector('[name=b_year]'),
            dataMonth = document.querySelector('[name=b_month]'),
            dataDay = document.querySelector('[name=b_day]'),
            dataDate = [dataYear.value, dataMonth.value, dataDay.value],
            resDate = parseInt(isAge());
        resDate == 6 ? this.validValidate(fieldEl) : this.invalidValidate(fieldEl,fieldReg['birthday']['fieldTooltip'][resDate][formLang]);
        [0,1,2,5].includes(resDate) ? invalidDate('b_year') : validDate('b_year');
        [0,3,4,5].includes(resDate) ? invalidDate('b_day') : validDate('b_day');
        resDate == 5 ? invalidDate('b_month') : validDate('b_month');
        function isAge(){
            var d = new Date(dataDate[0], dataDate[1]-1, dataDate[2]),
                dateAgeLimit = new Date(d.getFullYear() + ageLimit, d.getMonth(), d.getDate()),
                flagYear = !dataDate[0].match(fieldReg['birthday']['pattern']['year']),
                flagDay = !dataDate[2].match(fieldReg['birthday']['pattern']['day']);
            if ((flagYear && flagDay) || (dataDate[0].length < 4 && dataDate[2].length < 2) || (flagYear && dataDate[2].length < 2) || (dataDate[0].length < 4 && flagDay)){
                return 0;
            }else if(flagYear){
                return 1;
            }else if(dataDate[0].length < 4){
                return 2;
            }else if(flagDay || (dataDate[2] > 31) || (dataDate[2] > 30 && [4,6,9,11].includes(parseInt(dataDate[1]))) || (dataDate[2] > 29 && dataDate[1] == 2)){
                return 3;
            }else if(dataDate[2].length < 2){
                return 4;
            }
            return dateAgeLimit > new Date() ? 5 : 6;
        }
        function invalidDate(fieldName) {
            var dataGroup = document.querySelector("[name="+fieldName+"]").parentNode;
            dataGroup.classList.add('date__invalid');
        }
        function validDate(fieldName) {
            var dataGroup = document.querySelector("[name="+fieldName+"]").parentNode;
            dataGroup.classList.remove('date__invalid');
        }
    },
    emailValidate: function (fieldName,fieldVal) {
        !fieldVal.match(fieldReg['email']['pattern']) ? this.invalidValidate(fieldEl,fieldReg['email']['fieldTooltip'][formLang]) : this.lengthValidate(fieldName);
    },
    passwordValidate: function(fieldName,fieldVal) {
        if(!fieldVal.match(fieldReg['pass']['pattern'])){
            this.invalidValidate(fieldEl,fieldReg['pass']['fieldTooltip'][formLang])
        } else if(fieldPassRepeat[idForm] !== undefined && selected(fieldPassRepeat[idForm], fieldName)){
            passConfirm.length === 0 ? (passConfirm.push(fieldVal), this.validValidate(fieldEl)) : (passConfirm[0] === fieldVal ? this.validValidate(fieldEl) : this.invalidValidate(fieldEl,fieldReg['pass']['fieldTooltipCorrectly'][formLang]));
        } else {
            this.validValidate(fieldEl);
        }
    },
    noNumberValidate: function(fieldName,fieldVal) {
        !fieldVal.match(fieldReg['noNumber']['pattern'][formLang]) ? this.invalidValidate(fieldEl,fieldReg['noNumber']['fieldTooltip'][formLang]) : this.lengthValidate(fieldName);
    },
    onlyNumberValidate: function(fieldName,fieldVal) {
        !fieldVal.match(fieldReg['onlyNumber']['pattern']) ? this.invalidValidate(fieldEl,fieldReg['onlyNumber']['fieldTooltip'][formLang]) : this.lengthValidate(fieldName);
    },
    telValidate: function(fieldName,fieldVal) {
        fieldVal ? (iti.isValidNumber() ? (this.validValidate(fieldEl), inputTel.value = iti.getNumber()) : this.invalidValidate(fieldEl,errorMap[iti.getValidationError()][formLang])) : this.invalidValidate(fieldEl,fieldTooltipText['phone'][formLang]);
     },
    uploadValidate: function(fieldEl,fieldVal) {
        var formGroup = fieldEl.closest('.form__group-file');
        fieldEl.getAttribute('data-error') ? this.invalidValidate(fieldEl,fieldTooltipText['file'][formLang]) : (fieldVal ? this.validValidate(fieldEl) : formGroup.classList.remove('form__group-valid'));
    },
    captchaVal: function(fieldEl) {
        var captchaEl = document.querySelectorAll('.captcha');
        for (var i = 0; i < captchaEl.length; i++){
            if(fieldEl.getAttribute('id') === captchaEl[i].getAttribute('id')){
                return grecaptcha.enterprise.getResponse(i);
            }
        }
    },
    captchaValidate: function(fieldEl) {
        this.captchaVal(fieldEl) === 0 ? this.invalidValidate(fieldEl,fieldTooltipText['captcha'][formLang]) : this.validValidate(fieldEl);
    },
    addTooltip: function(fieldEl,fieldTooltip,state){
        var formGroup = fieldEl.closest('.form__group');
        var fieldFileTooltip = fieldEl.getAttribute('text-error') ? fieldEl.getAttribute('text-error') : fieldTooltip;
        var createTooltip = function (fieldTooltip,state) {
            var tooltip = document.createElement('div');
            tooltip.classList.add('form__tooltip');
            if(!state){
                tooltip.className = 'form__tooltip';
                formGroup.classList.remove('form__group-valid');
                formGroup.classList.add('form__group-invalid');
            }else{
                tooltip.className = 'form__tooltip';
                formGroup.classList.remove('form__group-invalid');
                formGroup.classList.add('form__group-valid');
            }
            tooltip.innerHTML = '<span>'+ fieldFileTooltip +'</span>';
            return tooltip;
        };
        //if(formGroup.lastElementChild.classList.contains('form__tooltip')) removeChild(formGroup.lastElementChild);
        $(formGroup).find('.form__tooltip').remove();
        if(formGroup) formGroup.appendChild(createTooltip(fieldTooltip,state));
        if($('#aside').hasClass('popup')) minHW();
    },
    invalidValidate: function(fieldEl,fieldTooltip) {
        this.addTooltip(fieldEl,fieldTooltip,false);
        fieldValid.push(false);
    },
    validValidate: function(fieldEl) {
        this.addTooltip(fieldEl,'field confirmed', true);
        fieldValid.push(true);
    }
}
//for CLEAR FORM
function  clearField(form) {
    var validatorEl = form.getAttribute('id'),
        input = form.querySelectorAll('input'),
        textarea = form.querySelectorAll('textarea'),
        checkBox = form.querySelectorAll('[type=checkbox].required'),
        checkRadio = form.querySelectorAll('[type=radio].required'),
        formGroup = form.querySelectorAll('.form__group'),
        formTooltip = form.querySelectorAll('.form__tooltip'),
        resetCaptcha = function () {
            if(!document.querySelectorAll(".captcha").length) return;
            var fieldCaptcha = document.querySelectorAll(".captcha");
            for (var i = 0; i < fieldCaptcha.length; i++) grecaptcha.enterprise.reset(i);
        };
    for (var i = 0; i < formGroup.length; i++){
        formGroup[i].classList.remove('form__group-valid');
        formGroup[i].classList.remove('form__group-invalid');
        if (!selected(notClearForm, validatorEl)) formGroup[i].classList.remove('activate');
    }
    for (var i = 0; i < formTooltip.length; i++) removeChild(formTooltip[i]);
    if (!selected(notClearForm, validatorEl)) {
        if(input.length) for (var i = 0; i < input.length; i++) input[i].value = '';
        if(textarea.length) for (var i = 0; i < textarea.length; i++) textarea[i].value = '';
        if(checkBox.length) for (var i = 0; i < checkBox.length; i++) checkBox[i].checked = false;
        if(checkRadio.length) for (var i = 0; i < checkRadio.length; i++) checkRadio[i].checked = false;
        if(uploader) uploader.reset();
        resetCaptcha();
    }
}
//for RESET FORM
function resetForm() {
    if(!document.querySelectorAll('[type="reset"]').length) return;
    var reset = document.querySelectorAll('[type="reset"]');
    for(var i = 0; i < reset.length; i++) reset[i].addEventListener('click', clearField(reset[i].closest('form')));
}
//for SELECT PLUGIN
function initSelect(){
    if(!document.querySelectorAll('.select').length) return;
    var select = document.querySelectorAll('.select');
    for(var i = 0; i < select.length; i++){
        var parent = select[i].parentNode;
        if(!parent.classList.contains('choices__inner')){
            var choices = new Choices(select[i], optionSelect(select[i]));
        }
    }
}
function optionSelect(el){
    var option =
        el.hasAttribute('data-picker') ?
            (el.getAttribute('data-picker') == 'hour'
                    ? { position: 'bottom',
                        searchEnabled: false,
                        classNames: {containerOuter: 'choices choices-left'},
                        callbackOnInit: dropdown
                    }
                    : { position: 'bottom',
                        searchEnabled: false,
                        classNames: {containerOuter: 'choices choices-right'},
                        callbackOnInit: dropdown
                    }
            )
            :
            (el.classList.contains('country') || el.classList.contains('city')
                    ? {position: 'bottom',
                        searchEnabled: true,
                        classNames: { containerOuter: el.classList.contains('country') ? 'choices country' : 'choices city' },
                        callbackOnInit: dropdown
                    }
                    : { position: 'bottom',
                        searchEnabled: false,
                        callbackOnInit: dropdown
                    }
            );
    return option;
}
function dropdown() {
    var dropdown = this.dropdown.element;
    var dropdownList = dropdown.querySelector('.choices__list');
    dropdown.setAttribute('data-scrollbar',true);
    $(dropdownList).scrollbar();
}
//for VALIDATE FORM
function validateForm(){
    if(!document.querySelectorAll('form').length) return;
    var form = document.querySelectorAll('form');
    for(var i = 0; i < form.length; i++){
        //for LABEL STATE
        if(form[i].querySelectorAll('label').length){
            var label = form[i].querySelectorAll('label');
            var activeField = function (e) {
                var el = e.target !== undefined ? e.target : e;
                var event = e.target !== undefined ? e.type : '';
                var formGroup = e.target !== undefined ? el.closest('.form__group') : e.closest('.form__group');
                if(formGroup){
                    if(event === 'focus'){
                        formGroup.classList.add('focus');
                    }else if(event === 'blur'){
                        formGroup.classList.remove('focus');
                    }else if(event === 'keyup' || event === 'change'){
                        el.value ? formGroup.classList.add('activate') : formGroup.classList.remove('activate');
                    }else if(el.value){
                        formGroup.classList.add('activate');
                    }
                }
            };
            for(var j = 0; j < label.length; j++){
                var idField = label[j].getAttribute('for');
                var field = document.getElementById(idField);
                if(field){
                    if(selected(focusField, idField)){
                        field.focus();
                        field.closest('.form__group').classList.add('focus');
                    }
                    activeField(field);
                    field.addEventListener('focus', activeField);
                    field.addEventListener('blur', activeField);
                    field.addEventListener('keyup', activeField);
                    field.addEventListener('change', activeField);
                }
            }
        }
        //for VALIDATE FIELDS
        if(form[i].querySelectorAll('.required').length){
            var $fieldRequired = form[i].querySelectorAll('.required');
            for(var j = 0; j < $fieldRequired.length; j++){
                $fieldRequired[j].addEventListener('keyup', Required.requiredField);
                $fieldRequired[j].addEventListener('change', Required.requiredField);
            }
        }
    }
}
//for INIT FORMS
document.addEventListener("DOMContentLoaded", function() {
    initTelInput(), validateForm(), resetForm();
});
